import { render, staticRenderFns } from "./AppointmentRecords.vue?vue&type=template&id=5061496a&scoped=true"
import script from "./AppointmentRecords.vue?vue&type=script&lang=js"
export * from "./AppointmentRecords.vue?vue&type=script&lang=js"
import style0 from "./AppointmentRecords.vue?vue&type=style&index=0&id=5061496a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061496a",
  null
  
)

export default component.exports